<template>
  <b-badge
    :class="this.class || ['font-size-80', 'text-uppercase', 'font-weight-500']"
    :variant="variant"
  >
    <slot v-if="!label">{{ label }}</slot>
    <template v-else>{{ label }}</template>
  </b-badge>
</template>

<script>
  export default {
    name: 'TaggingBadge',
    props: {
      label: {
        type: String,
        default: '',
      },
      variant: {
        type: String,
        default: 'secondary',
      },
    },
    computed: {
      class() {
        return this.$attrs.class;
      },
    },
  };
</script>
